import cn from "classnames";
import { useTranslation } from "react-i18next";

import {
  WorkspaceEngine,
  WorkspaceEngineStatus,
  isEngineStatusActive,
} from "services/engines/engine.types";

import styles from "./EngineStatusIndicator.module.scss";

const STATUS_LABEL_KEY: Record<WorkspaceEngineStatus, string> = {
  [WorkspaceEngineStatus.RUNNING]: "engine.status.running",
  [WorkspaceEngineStatus.STOPPED]: "engine.status.stopped",
  [WorkspaceEngineStatus.STOPPING]: "engine.status.stopping.compact",
  [WorkspaceEngineStatus.STARTING]: "engine.status.starting.compact",
  [WorkspaceEngineStatus.RESIZING]: "engine.status.resizing.compact",
  [WorkspaceEngineStatus.DRAINING]: "engine.status.draining.compact",
};

type Props = {
  engine: WorkspaceEngine;
};

export const EngineStatusIndicator = (props: Props) => {
  const { engine } = props;
  const { t } = useTranslation();

  return (
    <div
      data-testid="engine-status-indicator"
      className={cn(styles.indicator, {
        [styles.active]: isEngineStatusActive(engine.status),
      })}
    >
      <span className={styles.label}>{t(STATUS_LABEL_KEY[engine.status])}</span>
    </div>
  );
};
